import React from 'react';
import ReactDOM from 'react-dom/client'; // ✅ updated import
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import store from './store';

// ✅ Create root and use the new render method
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// Optional: performance monitoring
reportWebVitals();
